// extracted by mini-css-extract-plugin
export var active = "_5b-7";
export var container = "_5b-0";
export var evenWidth = "_5b-4";
export var large = "_5b-5";
export var outlet = "_5b-8";
export var slide = "_5b-2";
export var small = "_5b-6";
export var tab = "_5b-3";
export var tabs = "_5b-1";